export const DEACTIVATE_TEST_DRIVE = 'DEACTIVATE_TEST_DRIVE';

export const deactivateTestDrive = () => dispatch => dispatch({ type: DEACTIVATE_TEST_DRIVE });
